export default __webpack_public_path__ + "4ffa074d3aa4cf859d37b36450917b9a.png";